import React, { FC } from "react";
import { Box, SxProps } from "@mui/material";
import { PropertiesCard } from "shared-ts-ui-properties-card";
import { Formik } from "formik";
import { FormikHelpers } from "formik/dist/types";
import {
  Chimney,
  ChimneyUpdateSpec,
  useChimneyDao,
} from "firefly-my-chimney-ts-building";
import { useTranslation } from "react-i18next";
import { CustomerEnvironmentId } from "firefly-shared-ts-customer-environment";
import { Property } from "shared-ts-property";
import { Button } from "@mui/material";

export interface ChimneyFormValues {
  name: string;
}

export interface ChimneyFormProps {
  environment: CustomerEnvironmentId;
  chimney: Chimney;
  sx?: SxProps;
  onChange: (update: ChimneyUpdateSpec) => void;
}
export const ChimneyForm: FC<ChimneyFormProps> = (props) => {
  const { chimney, environment } = props;
  const { t } = useTranslation("my-chimney-ts-translations");
  const { t: tSharedDomain } = useTranslation("firefly-shared-ts-domain");
  const chimneyDao = useChimneyDao(environment);
  const formInitialValues: ChimneyFormValues = {
    name: chimney.mcFields?.name ?? "",
  };
  const handleSubmit = async (
    values: ChimneyFormValues,
    formikHelpers: FormikHelpers<ChimneyFormValues>
  ) => {
    const update: ChimneyUpdateSpec = {
      type: "ChimneyUpdateSpec",
      id: chimney.id,
      securityToken: chimney.securityToken,
      name: { value: values.name.notEmptyOrNull() },
    };
    await chimneyDao.update(update);
    props.onChange(update);
  };

  return (
    <Box sx={props.sx}>
      <Formik
        initialValues={formInitialValues}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({
          dirty,
          values,
          errors,
          resetForm,
          submitForm,
          isSubmitting,
          setFieldValue,
        }) => {
          const handleSaveClick = () => {
            return submitForm();
          };
          return (
            <Box>
              <PropertiesCard
                elevation={0}
                header={{
                  title: t("Your Settings"),
                }}
              >
                <Property
                  label={tSharedDomain("Name")}
                  name={"name"}
                  value={values.name}
                  mode={"edit"}
                  helperText={t("Your name on the chimney")}
                  onChange={(value, name) => setFieldValue(name, value)}
                />
              </PropertiesCard>
              <Button
                color={"secondary"}
                variant={"outlined"}
                disabled={!dirty}
                loading={isSubmitting}
                onClick={handleSaveClick}
              >
                {t("Save")}
              </Button>
            </Box>
          );
        }}
      </Formik>
    </Box>
  );
};
